import { useLightbox } from "@/providers/LightboxProvider";

const Lightbox = () => {
  const { isOpen, src, alt, closeLightbox } = useLightbox();

  const handleBackgroundClick = () => {
    // Close the modal if the background is clicked
    closeLightbox();
  };

  const handleImageClick = (e) => {
    // Stop propagation to prevent closing modal when image is clicked
    e.stopPropagation();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75" onClick={handleBackgroundClick}>
      <div className="relative">
        <button className="absolute top-2 right-2 text-2xl text-white" onClick={closeLightbox}>
          &times;
        </button>
        <img onClick={handleImageClick} src={src} alt={alt} className="size-auto max-h-[80vh]" />
      </div>
    </div>
  );
};

export default Lightbox;
